import { IUser } from 'app/shared/model/user.model';
import { IFolder } from 'app/shared/model/folder.model';

export interface IToDoItem {
  id?: number;
  title?: string | null;
  description?: string | null;
  user?: IUser;
  folder?: IFolder | null;
}

export const defaultValue: Readonly<IToDoItem> = {};
